export default __webpack_public_path__ + "static/media/projects-illustration.674e7061.webp";